<div class="animation-fade-in animation-duration-240s w-100">
	<div class="d-flex">
		<div class="product-name text-center mx-3">
			{{ canvasMenuItem.displayName || canvasMenuItem.ooMenuItem.name }}
		</div>
	</div>
	<div class="d-flex">
		<div class="product-list-item">
			<img
				*ngIf="canvasMenuItem.ooMenuItem.imageKey"
				class=""
				[src]="
					'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' +
					venueService.ooVenue.venueKey +
					'/' +
					canvasMenuItem.menuItemKey +
					'.png?' +
					timestamp
				"
				onError="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + (venue.linkedVenueKey || venueKey) + '/default.png?' + timestamp"
				[alt]="canvasMenuItem.displayName || canvasMenuItem.ooMenuItem.name"
			/>
			<img
				*ngIf="!canvasMenuItem.ooMenuItem.imageKey"
				class=""
				[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueService.ooVenue.venueKey + '/default.png?' + timestamp"
				onError="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/default.png'"
				[alt]="canvasMenuItem.displayName || canvasMenuItem.ooMenuItem.name"
			/>
		</div>
		<div class="mt-2 ms-auto d-flex justify-content-end">
			<div class="product-list-detail text-end">
				<div class="product-list-action justify-content-end">
					<p-button
						pRipple
						styleClass="p-button-raised p-button-buttonColor"
						(click)="onItemSelect(canvasMenuItem)"
						[disabled]="canvasMenuItem.ooMenuItem.outOfStock"
					>
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">
								<fa-icon [icon]="['far', 'shopping-cart']" size="lg" class="ms-1 me-2"> </fa-icon>
								{{ venueService.menuItemGetPriceFromNumber(canvasMenuItem.ooMenuItem, canvasMenuItem.priceNumber) | currency }}
							</div>
						</ng-template>
					</p-button>
				</div>
				<div class="mt-2 text-end">
					<p-tag *ngIf="canvasMenuItem.ooMenuItem.outOfStock" value="Out of Stock" severity="danger" class="ms-auto"></p-tag>
					<p-tag
						*ngIf="canvasMenuItem.ooMenuItem.countdown"
						[value]="venueService.ooVenue.limitedAvailabilityTag || 'Limited availability'"
						severity="warning"
					></p-tag>
					<ng-container *ngFor="let tag of canvasMenuItem.ooMenuItem.OOMenuItemTags">
						<p-tag [value]="tag.OOTags.name" styleClass="m-1 overflow-auto" [severity]="tag.OOTags.severity"> </p-tag>
					</ng-container>
					<ng-container *ngFor="let frequency of canvasMenuItem.subscriptionAllowedFrequencies">
						<p-tag
							[value]="venueService.subscriptionFrequencyToFrequencyDisplayName(frequency)"
							styleClass="m-1 overflow-auto"
							severity="success"
						></p-tag>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
	<div class="p-grid">
		<div class="p-col">
			<div class="product-description">{{ canvasMenuItem.description }}</div>
		</div>
	</div>
</div>
